export function openRegulationFilterDrawer() {
    return {
        type: 'REGULATION_FILTER_DRAWER_OPEN',
    }
}

export function closeRegulationFilterDrawer() {
    return {
        type: 'REGULATION_FILTER_DRAWER_CLOSE',
    }
}

export function openTaskFilterDrawer() {
    return {
        type: 'TASK_FILTER_DRAWER_OPEN',
    }
}

export function closeTaskFilterDrawer() {
    return {
        type: 'TASK_FILTER_DRAWER_CLOSE',
    }
}


// WEBPACK FOOTER //
// ./src/redux/actions/drawer.js